import React from 'react';
import Lottie from 'lottie-react';

import { useTabSettings } from 'utils/hooks/useTabSettings';
import { HOME_STATUS } from 'components/evieApp/utils';
import heartLoader from 'assets/heart-loader.json';

import Layout from 'components/evieOnboarding/Layout';
import BottomNav from 'components/evieApp/BottomNav';
import HomeContent from 'components/evieApp/HomeContent';
import ProgramHome from 'components/evieApp/ProgramHome';
import ProgramInfo from 'components/evieApp/ProgramInfo';
import DailyExercises from 'components/evieApp/DailyExercises';
import TaskController from 'components/evieApp/TaskController';
import SqueezeView from 'components/evieApp/SqueezeView';
import SessionExerciseInfo from 'components/evieApp/SessionExerciseInfo';
import FeedbackView from 'components/evieApp/FeedbackView';
import { useEvieAppContext } from 'components/evieApp/EvieAppProvider';
import { useEvieHomeContext } from 'components/evieApp/EvieHomeProvider';

import './evie-home.scss';

const EvieHome = () => {
  useTabSettings('Evie', '/evie-favicon.ico');
  const { loading, isPremium } = useEvieAppContext();
  const { homeStatus, selectedTask, selectTask, changeHomeStatus } = useEvieHomeContext();

  const displayBottomNav = [HOME_STATUS.PROGRAM, HOME_STATUS.SESSION, HOME_STATUS.IDLE].includes(homeStatus);

  return (
    <>
      <Layout>
        {!loading && displayBottomNav && <BottomNav />}
        <div key={homeStatus} className="evie-fade-in">
          {!loading && homeStatus === HOME_STATUS.IDLE && (isPremium ? <ProgramHome /> : <HomeContent />)}
          {!loading && homeStatus === HOME_STATUS.PROGRAM && <ProgramInfo />}
          {!loading && homeStatus === HOME_STATUS.EXERCISES && (
            <DailyExercises
              changeViewStatus={() => changeHomeStatus(HOME_STATUS.IDLE)}
              selectContent={selectTask}
              selectedContent={selectedTask}
            />
          )}
          {!loading && homeStatus === HOME_STATUS.SESSION && <SessionExerciseInfo />}
          {!loading && homeStatus === HOME_STATUS.TASK && <TaskController />}
          {!loading && homeStatus === HOME_STATUS.SQUEEZE && <SqueezeView />}
          {!loading && homeStatus === HOME_STATUS.FEEDBACK && <FeedbackView />}
        </div>
      </Layout>
      {loading && (
        <div className="onboarding-layout__lottie">
          <Lottie animationData={heartLoader} loop style={{ width: 140, height: 110 }} />
        </div>
      )}
    </>
  );
};

export default EvieHome;
